import { FC } from 'react';

import UserEditForm from './components/UserEditForm/UserEditForm';
import UserProfile from './components/UserProfile/UserProfile';
import useProfilePage from './hooks/useProfilePage';
import { ButtonIconStyled, FlexContainerStyled, MainContainerStyled } from './ProfilePage.styled';
import Header from 'components/Header/Header';
import Typography from 'components/Typography/Typography';
import { useResponsive } from 'contexts/ResponsiveContext';
import { useUserProfile } from 'contexts/UserProfileContext';
import { CloseIcon } from 'icons';

const ProfilePage: FC = () => {
  const { isMobile } = useResponsive();
  const { handleSubmitForm, handleDeleteImgBtnClick } = useProfilePage();
  const { userProfile } = useUserProfile();

  return (
    <div>
      <Header />
      <MainContainerStyled>
        <Typography variant="h2" color="darkBlue">
          Profile Page
        </Typography>
        <FlexContainerStyled
          align="start"
          justify="between"
          direction={isMobile ? 'column' : 'row'}
        >
          <UserProfile />
          {userProfile?.photoUrl && (
            <ButtonIconStyled
              icon={<CloseIcon />}
              title="Delete image"
              onClick={handleDeleteImgBtnClick}
            />
          )}

          {userProfile && <UserEditForm onSubmit={handleSubmitForm} />}
        </FlexContainerStyled>
      </MainContainerStyled>
    </div>
  );
};

export default ProfilePage;
